var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Person_1;
import { XSDDate } from 'lincd-xsd/shapes/XSDDate';
import { Literal } from 'lincd/models';
import { literalProperty, objectProperty } from 'lincd/shapes/SHACL';
import { schema } from '../ontologies/schema.js';
import { linkedShape } from '../package.js';
import { Place } from './Place.js';
import { Thing } from './Thing.js';
import { ShapeValuesSet } from 'lincd/collections/ShapeValuesSet';
import { PostalAddress } from './PostalAddress.js';
import { xsd } from 'lincd-xsd/ontologies/xsd';
import { Boolean } from 'lincd-xsd/shapes/Boolean';
import { DefinedTerm } from './DefinedTerm.js';
import { AdministrativeArea } from './AdministrativeArea.js';
let Person = Person_1 = class Person extends Thing {
    get givenName() {
        return this.getValue(schema.givenName);
    }
    set givenName(val) {
        this.overwrite(schema.givenName, new Literal(val));
    }
    get familyName() {
        return this.getValue(schema.familyName);
    }
    set familyName(val) {
        this.overwrite(schema.familyName, new Literal(val));
    }
    get name() {
        return this.getValue(schema.name);
    }
    get gender() {
        return this.getValue(schema.gender);
    }
    set gender(val) {
        this.overwrite(schema.gender, val ? new Literal(val) : null);
    }
    get isMarried() {
        return Boolean.isTrue(this.getOne(schema.isMarried));
    }
    set isMarried(val) {
        this.overwrite(schema.isMarried, val ? Boolean.true() : Boolean.false());
    }
    get telephone() {
        return this.getValue(schema.telephone);
    }
    set telephone(val) {
        this.overwrite(schema.telephone, val ? new Literal(val) : null);
    }
    get birthDate() {
        return this.hasProperty(schema.birthDate)
            ? XSDDate.toNativeDate(this.getOne(schema.birthDate))
            : null;
    }
    set birthDate(nativeDate) {
        this.overwrite(schema.birthDate, nativeDate ? XSDDate.fromNativeDate(nativeDate).node : null);
    }
    static getAge(birthDate) {
        // if (this.hasProperty(schema.birthDate) === false) return null;
        var today = new Date();
        // var birthDate = this.birthDate;
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
    get birthPlace() {
        return this.getOneAs(schema.birthPlace, Place);
    }
    set birthPlace(val) {
        this.overwrite(schema.birthPlace, val ? val.node : null);
    }
    get knows() {
        return this.getAllAs(schema.knows, Person_1);
    }
    get skills() {
        //return this.getAll(schema.skills).map((skill) => skill.value);
        return this.getAllAs(schema.skills, DefinedTerm);
    }
    get jobTitle() {
        return this.getValue(schema.jobTitle);
    }
    set jobTitle(val) {
        this.overwrite(schema.jobTitle, new Literal(val));
    }
    //TODO: schema.hasOccupation -> schema:Occupation (shape to be created)
    get hasOccupation() {
        return this.getValue(schema.hasOccupation);
    }
    set hasOccupation(val) {
        this.overwrite(schema.hasOccupation, new Literal(val));
    }
    get homeLocation() {
        return this.getAllAs(schema.homeLocation, Place);
    }
    get honorificPrefix() {
        return this.getValue(schema.honorificPrefix);
    }
    set honorificPrefix(val) {
        this.overwrite(schema.honorificPrefix, new Literal(val));
    }
    // TODO: remove this after do migration restructure location
    get areaServed() {
        return this.getOneAs(schema.areaServed, AdministrativeArea);
    }
    set areaServed(val) {
        this.overwrite(schema.areaServed, val ? val.node : null);
    }
    get address() {
        return this.getOneAs(schema.address, PostalAddress);
    }
    set address(val) {
        this.overwrite(schema.address, val ? val.namedNode : null);
    }
};
Person.targetClass = schema.Person;
__decorate([
    literalProperty({
        path: schema.givenName,
        maxCount: 1,
        datatype: xsd.string,
        description: 'The given name of the person.',
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "givenName", null);
__decorate([
    literalProperty({
        path: schema.familyName,
        maxCount: 1,
        datatype: xsd.string,
        description: 'The family name of the person.',
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "familyName", null);
__decorate([
    literalProperty({
        path: schema.name,
        maxCount: 1,
        datatype: xsd.string,
        description: 'Use as optional altnertive name. Is more likely to have a defined givenName and familyName as primary names.',
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Person.prototype, "name", null);
__decorate([
    literalProperty({
        path: schema.gender,
        maxCount: 1,
        datatype: xsd.string,
        // in: [
        //   new Literal('male'),
        //   new Literal('female'),
        //   new Literal('prefer not to say'),
        // ],
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "gender", null);
__decorate([
    literalProperty({
        path: schema.isMarried,
        datatype: Boolean.targetClass,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], Person.prototype, "isMarried", null);
__decorate([
    literalProperty({
        path: schema.telephone,
        maxCount: 1,
        datatype: xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "telephone", null);
__decorate([
    literalProperty({
        path: schema.birthDate,
        maxCount: 1,
        datatype: xsd.dateTime,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Person.prototype, "birthDate", null);
__decorate([
    objectProperty({
        path: schema.birthPlace,
        shape: Place,
        maxCount: 1,
    }),
    __metadata("design:type", Place),
    __metadata("design:paramtypes", [Place])
], Person.prototype, "birthPlace", null);
__decorate([
    objectProperty({
        path: schema.knows,
        shape: Person,
    }),
    __metadata("design:type", ShapeValuesSet),
    __metadata("design:paramtypes", [])
], Person.prototype, "knows", null);
__decorate([
    objectProperty({
        path: schema.skills,
        shape: DefinedTerm,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "skills", null);
__decorate([
    literalProperty({
        path: schema.jobTitle,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "jobTitle", null);
__decorate([
    literalProperty({
        path: schema.hasOccupation,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "hasOccupation", null);
__decorate([
    objectProperty({
        path: schema.homeLocation,
        shape: Place,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "homeLocation", null);
__decorate([
    literalProperty({
        path: schema.honorificPrefix,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "honorificPrefix", null);
__decorate([
    objectProperty({
        path: schema.areaServed,
        shape: Person,
        maxCount: 1,
    }),
    __metadata("design:type", AdministrativeArea),
    __metadata("design:paramtypes", [AdministrativeArea])
], Person.prototype, "areaServed", null);
__decorate([
    objectProperty({
        path: schema.address,
        shape: PostalAddress,
        maxCount: 1,
    }),
    __metadata("design:type", PostalAddress),
    __metadata("design:paramtypes", [PostalAddress])
], Person.prototype, "address", null);
Person = Person_1 = __decorate([
    linkedShape({
        description: 'A person (alive, dead, fictional); can be a member, leader, or contact for organizations. Holds identifiers and contact details. (individual, human, actor, user)',
    })
], Person);
export { Person };
//# sourceMappingURL=Person.js.map